import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextField } from "@material-ui/core";

class OptionsGenerator extends Component {
  state = {
    fieldsAmount: [{ key: "", val: "" }],
    finalString: ""
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">ייצור אופציות נוספות</DialogTitle>
          <DialogContent>
            {this.state.fieldsAmount.map((field, index) => {
              return (
                <div key={index} className="mb-20">
                  <div className="inline-block padding10">
                    <TextField
                      required
                      label="קוד"
                      className="field-strech"
                      autoComplete="current-email"
                      onChange={(e) => {
                        this.handleChange(e, "key", index);
                      }}
                    />
                  </div>
                  <div className="inline-block">
                    <TextField
                      required
                      label="טקסט"
                      className="field-strech"
                      autoComplete="current-email"
                      onChange={(e) => {
                        this.handleChange(e, "val", index);
                      }}
                    />
                  </div>
                </div>
              );
            })}
            <div className="mt-40">
              <Button
                className="mr-20 mt-20"
                onClick={this.addOption}
                color="secondary"
                variant="contained"
                size="small"
              >
                <i className="material-icons width40">add</i>
              </Button>
              <Button
                className="mr-20 mt-20"
                onClick={this.createOptions}
                color="secondary"
                variant="contained"
                size="small"
              >
                ייצר
              </Button>
            </div>
            <div className="mt-20">{this.state.finalString}</div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cleanAndClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  cleanAndClose = () => {
    this.setState({ fieldsAmount: [{ key: "", val: "" }] });
    this.props.closePopup();
  };

  handleChange = (e, type, index) => {
    var fieldsAmount = [...this.state.fieldsAmount];
    fieldsAmount[index][type] = e.target.value;
    this.setState({ fieldsAmount });
  };

  addOption = () => {
    var fieldsAmount = [...this.state.fieldsAmount];
    fieldsAmount.push({ key: "", val: "" });
    this.setState({ fieldsAmount });
  };

  createOptions = () => {
    var totalOptionsString = "";
    for (const option of this.state.fieldsAmount) {
      totalOptionsString += `${option.key}|${option.val};`;
    }

    totalOptionsString = totalOptionsString.substring(0, totalOptionsString.length - 1);
    this.setState({ finalString: totalOptionsString });
  };
}

export default OptionsGenerator;
